/**
 * Extract widget configuration
 *
 * @param  {string} scope The globalscope name where config lives
 * @return {object}
 */
export function extractWidgetConfig (scope) {
    let configVarName = window[scope];
    let params = [];
    let options = {};

    if (configVarName === void (0)) {
        throw new Error('Widget init with wrong config container');
    }

    params = window[configVarName].q || [];
    params.forEach((currentValue, index, array) => {
        let name = Array.prototype.slice.call(currentValue, 0, 1)[0];
        options[name] = Array.prototype.slice.call(currentValue, 1)[0];
    });

    return options;
};



// WEBPACK FOOTER //
// ./src/utils/config.js